import { render } from "./ZipType.vue?vue&type=template&id=05adb8fe"
import script from "./ZipType.vue?vue&type=script&lang=js"
export * from "./ZipType.vue?vue&type=script&lang=js"

import exportComponent from "/home/jeim2750/develop.fuelguide.be/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__